import { ISelectedPromotionInfo, ECheckServicePromotionType, ECheckServicePublicationType } from '../types';
import { mapInternalServiceTypes, getServiceId } from '../../../utils/publishTerms';
import { ISelectedPromotionInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/SelectedPromotionInfoSchema';
import { EServiceType } from '../../../types/reducers/publishTerms';

export function mapSelectedPromotionInfo(selectedPromotionInfo: ISelectedPromotionInfoSchema): ISelectedPromotionInfo {
  const serviceTypes = mapInternalServiceTypes<EServiceType>(selectedPromotionInfo.serviceTypes);

  return {
    publicationType: selectedPromotionInfo.changedPublicationType as string as ECheckServicePublicationType,
    promotionType: selectedPromotionInfo.promotionType as string as ECheckServicePromotionType,
    promotionTypeChangeReason: selectedPromotionInfo.promotionTypeChangeReason,
    serviceId: getServiceId(serviceTypes),
  };
}
